<div class="product-logo-container">
  <div class="product-logo">
    <img src="assets/polya-logo.svg" alt=""/>
  </div>
</div>
